import React, { Fragment } from 'react';
import { Field } from 'formik';
import { Tags } from 'components/tags';
import { FovFieldError, VerticalSpacer } from 'components';
import { TagsContainer } from './RPCFormStyles';
import _ from 'lodash';

const TagsField = ({ form, theme, selectedTheme }) => {
  return (
    <Fragment>
      Tags*
      <VerticalSpacer size={10} />

      <TagsContainer theme={theme} $selectedTheme={selectedTheme}>
        <Field type='input' name='description'>
          {data => (
            <Tags
              values={_.isEmpty(data.field.value) ? [] : data.field.value.split(',')}
              onChange={(e, tags) => {
                form.setFieldValue(data.field.name, tags);
              }}
            />
          )}
        </Field>
      </TagsContainer>

      <FovFieldError name='description' />
    </Fragment>
  );
};

export default TagsField;

